import { Box, styled, Theme } from "@mui/material";

export const DiffCellContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
});

const diffLabelColor = (theme: Theme, isIncrease: boolean, onDark?: boolean): string => {
  const palette = isIncrease ? theme.palette.error : theme.palette.success;
  return onDark ? palette.light : palette.dark;
};

export const DiffLabel = styled("span", {
  shouldForwardProp: (prop) => prop !== "isIncrease" && prop !== "onDark",
})<{ isIncrease: boolean; onDark?: boolean }>(({ theme, isIncrease, onDark }) => ({
  display: "inline-flex",
  alignItems: "center",
  marginLeft: theme.spacing(0.5),
  fontSize: "0.7rem",
  fontWeight: 700,
  color: diffLabelColor(theme, isIncrease, onDark),
  "& svg": {
    fontSize: "0.85rem",
  },
}));
